import React, { useRef, useState } from "react";
import { getAPI, getAPIBatch } from "../../helpers/httpHelper";
import ISubContratista from "../../entities/ISubContratista";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import IGerencia from "../../entities/IGerencia";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { Col, Form, Row } from "react-bootstrap";
import { CellContext, createColumnHelper, Row as RowDT } from "@tanstack/react-table";
import {
  API_ADMIN_CONTRATISTA_SUBCONTRATISTA,
  API_ADMIN_GERENCIA,
  API_ADMIN_UNIDAD,
  API_VPP,
  ROW_COUNT,
  ROW_COUNT_MAX,
  URL_SUPPORT,
  API_ADMIN_TIPO_FAENA,
  API_ADMIN_FAENA,
  API_ADMIN_LIO_INSPECTOR_TRANSELEC,
  API_ADMIN_LIO_PREVENCIONISTA,
} from "../../helpers/variableHelper";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";

import { TextField } from "@fluentui/react";

import UserPickerData from "../../controls/UserPickerData";
import Select from "react-select";
import { IComboboxOption, ITypeWorkComboboxOption } from "../../entities/helper/IComboboxOption";
import DesviacionService from "../../services/DesviacionService";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { dateFormatInputReference, shortDate } from "../../helpers/dateHelper";
import { EnumTipoDocumentoAuditoria } from "../../entities/helper/EnumTipoDocumentoAuditoria";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getFileName } from "../../helpers/pathHelper";
import moment from "moment";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import { E_EstadoFormIngresarLIO } from "../../enums/E_EstadoFormulario";

import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import IDocumentoLIO from "../../entities/IDocumentoLIO";
import ITipoFaena from "../../entities/ITipoFaena";
import IFaena from "../../entities/IFaena";
import LIOService from "../../services/LIOService";
import IInspeccionObservacion, { IAspectoEvaluar, ISearchListadoAspectosInsObs } from "../../entities/IInspeccionObservacion";
import ILIOInspectorTranselec from "../../entities/ILIOInspectorTranselec";
import AspectoEvaluar from "./components/AspectoEvaluar";
import { E_EstadoLIO } from "../../enums/E_EstadoLIO";
import { E_EstadoTipoEvaluacionLIO } from "../../enums/E_EstadoTipoEvaluacionLIO";
import Loading from "../../cross/Loading";
import { ModalContinuarLio } from "./components/CerrarConObservaciones";
import { cParamsActive, cParamsActiveOrderTitle } from "../../helpers/paramsHelper";
import { itemsLIO } from "../../test/variableTest";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface IAgregarLIOProps {
  readonly: boolean;
  loading?: boolean;
  itemsDocumentos?: Array<IDocumentoLIO>;
  faenaTipo?: ITypeWorkComboboxOption;
  items?: Array<IAspectoEvaluar>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciaSubGerencia?: Array<IGerencia>;
  cbUnidadYProyecto?: Array<IUnidad>;
  cbContratistaSubcontratista?: Array<ISubContratista>;
  cbTipoFaena?: Array<ITipoFaena>;
  cbFaena?: Array<IFaena>;
  selectedLioTest?: IInspeccionObservacion;
  is_test?: boolean;
  id?: string;
  lioTest?: IInspeccionObservacion;
}
const AgregarLIO = ({
  readonly,
  loading = true,
  itemsDocumentos = [],
  faenaTipo,
  items = [] as Array<IAspectoEvaluar>,
  cbVicepresidencia,
  cbGerenciaSubGerencia,
  cbUnidadYProyecto,
  cbContratistaSubcontratista,
  cbTipoFaena,
  cbFaena,
  selectedLioTest,
  is_test,
  id,
  lioTest,
}: IAgregarLIOProps) => {
  // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 392 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  let search = new URLSearchParams(window.location.search);
  const idLIO = parseInt(search.get("id") || (id ?? "0"));
  const userInfoToken = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [documentosLIO, setDocumentosLIO] = useState<IDocumentoLIO[]>(itemsDocumentos || []);
  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>(cbGerenciaSubGerencia || []);
  const [comboCSC, setComboCSC] = useState<Array<ISubContratista>>(cbContratistaSubcontratista || []);
  const [comboUP, setComboUP] = useState<Array<IUnidad>>(cbUnidadYProyecto || []);
  const [comboTF, setComboTF] = useState<Array<ITipoFaena>>(cbTipoFaena || []);
  const [comboF, setComboF] = useState<Array<IFaena>>(cbFaena || []);
  const [inspeccionadoPor, setInspeccionadoPor] = useState<Partial<ILIOInspectorTranselec>[]>([]);
  const [selectedInspeccionadoPor, setSelectedInspeccionadoPor] = useState<Partial<ILIOInspectorTranselec> | null>();
  const refInputFile = React.createRef<HTMLInputElement>();
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const [fechaDeteccion, setFechaDeteccion] = useState<string>();
  const totalPageListLIO = useRef<number>(0);
  const [tf, setTF] = useState<ITypeWorkComboboxOption | null>(faenaTipo || null);
  const [fa, setF] = useState<IComboboxOption | null>(null);
  const [vpp, setVpp] = useState<IComboboxOption | null>(null);
  const [gsg, setGsg] = useState<IComboboxOption | null>(null);
  const [up, setUp] = useState<IComboboxOption | null>(null);
  const [cs, setCs] = useState<IComboboxOption | null>(null);
  const [numeroTrabajoRealizado, setNumeroTrabajoRealizado] = useState("");
  const [instalacionIntervenir, setInstalacionIntervenir] = useState("");
  const [jefeFaenaSupervisor, setJefeFaenaSupervisor] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [lenObservacionesInc, setLenObservacionesInc] = useState(0);
  const [lenDescripcionDoc, setLenDescripcionDoc] = useState(0);
  const [listLIOAspectosInsObs, setListLIOAspectosInsObs] = useState<Array<IAspectoEvaluar>>(items || []);
  const [listLIOAspectosInsObsFiltrado, setListLIOAspectosInsObsFiltrado] = useState<Array<IAspectoEvaluar>>(items || []);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [arrErrorEmptyFile, setArrErrorEmptyFile] = useState<Array<string>>([]);
  const [selectedLIO, setSelectedLIO] = useState<IInspeccionObservacion | null>(selectedLioTest || null);
  const [estadoFormulario] = useState<E_EstadoFormIngresarLIO>(readonly ? E_EstadoFormIngresarLIO.Lectura : E_EstadoFormIngresarLIO.Ingresar);
  const totalPageListDocumentos = useRef<number>(0);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isLoadingAspectos, setIsLoadingAspectos] = useState(false);
  const [isOpenPopUpApectoEvaluar, setIsOpenPopUpApectoEvaluar] = useState<boolean>();
  const [selectdAspectoEvaluar, setSelectedAspectoEvaluar] = useState<IAspectoEvaluar | null>(null);
  const [aspectoEvaluadoListaFaena, setAspectoEvaluadoListaFaena] = useState<Array<IAspectoEvaluar>>([]);
  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const [isExternalUserLIO, setIsExternalUser] = useState(false);
  const [isExternoInspector, setIsExternoInspector] = useState(false);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const vccDefaultValueValidation = () => {
    if (isExternalUserLIO) {
      return vpp;
    } else {
      return [];
    }
  };

  const componentListAspectos = (ae: any) => {
    if (tf !== null && !tf.newFormat && ae.ID_TIPO_EVALUACION === E_EstadoTipoEvaluacionLIO.SubEstandar) {
      return "Sub Estándar";
    } else if (tf !== null && tf.newFormat && ae.ID_TIPO_EVALUACION === E_EstadoTipoEvaluacionLIO.Aplica) {
      return "Aplica";
    } else {
      return "No Aplica";
    }
  };

  const componentExternalUser = () => {
    if (isExternalUserLIO) {
      return [
        {
          mail: currentUser?.email as string,
          name: currentUser?.fullname as string,
        },
      ];
    } else {
      return [];
    }
  };

  const componentAspectosEvaluados = (info: any) => {
    let color = "";
    let evaluacion = "";
    if (info.row.original.ASPECTO_EVALUADO == "") {
      return <></>;
    }
    if (info.getValue() == "3") {
      color = "badgeAzul";
      evaluacion = "No Aplica";
    } else if (info.getValue() == "2") {
      color = "badgeRojo";
      evaluacion = "Sub Estándar";
    } else {
      color = "badgeVerde";
      evaluacion = "Estándar";
    }
    return (
      <span className="radioLIO">
        {readonly ? (
          <span className={color}>{evaluacion}</span>
        ) : (
          <div className="d-flex ">
            <div className="form-check form-check-inline">
              <input
                data-testid="test1"
                className="form-check-input"
                type="radio"
                name={info.row.original.ID_ASPECTO?.toString()}
                id={info.row.original.ID_ASPECTO?.toString()}
                value="Estándar"
                checked={
                  info.row.original.ID_TIPO_EVALUACION == null || info.row.original.ID_TIPO_EVALUACION == E_EstadoTipoEvaluacionLIO.Estandar
                    ? true
                    : false
                }
                onClick={(e) => {
                  if (vpp == null || gsg == null) {
                    MySwal.fire({
                      title: <p>Debe completar todos los campos requeridos</p>,
                      icon: "error",
                    });
                  } else {
                    handleSetAspecto(info.row.original, E_EstadoTipoEvaluacionLIO.Estandar);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Estándar
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                data-testid="test2"
                className="form-check-input"
                type="radio"
                name={info.row.original.ID_ASPECTO?.toString()}
                id={info.row.original.ID_ASPECTO?.toString()}
                value="Sub Estándar"
                checked={info.row.original.ID_TIPO_EVALUACION == E_EstadoTipoEvaluacionLIO.SubEstandar ? true : false}
                onClick={(e) => {
                  if (vpp == null || gsg == null) {
                    MySwal.fire({
                      title: <p>Debe completar todos los campos requeridos</p>,
                      icon: "error",
                    });
                  } else {
                    setSelectedAspectoEvaluar(info.row.original);
                    setIsOpenPopUpApectoEvaluar(true);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Sub Estándar
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                data-testid="test3"
                className="form-check-input"
                type="radio"
                name={info.row.original.ID_ASPECTO?.toString()}
                id={info.row.original.ID_ASPECTO?.toString()}
                value="No Aplica"
                checked={info.row.original.ID_TIPO_EVALUACION === E_EstadoTipoEvaluacionLIO.NoAplica ? true : false}
                onClick={(e) => {
                  if (vpp == null || gsg == null) {
                    MySwal.fire({
                      title: <p>Debe completar todos los campos requeridos</p>,
                      icon: "error",
                    });
                  } else {
                    handleSetAspecto(info.row.original, E_EstadoTipoEvaluacionLIO.NoAplica);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="inlineRadio3">
                No Aplica
              </label>
            </div>
          </div>
        )}
      </span>
    );
  };
  const componentAspectosEvaluadosNuevoFormato = (info: any) => {
    let color = "";
    let evaluacion = "";
    if (info.row.original.ASPECTO_EVALUADO == "") {
      return <></>;
    }
    if (info.getValue() == "4") {
      color = "badgeVerde";
      evaluacion = "Aplica";
    } else {
      color = "badgeAzul";
      evaluacion = "No Aplica";
    }
    return (
      <span className="radioLIO">
        {readonly ? (
          <span className={color}>{evaluacion}</span>
        ) : (
          <div className="d-flex ">
            <div className="form-check form-check-inline">
              <input
                data-testid="test1"
                className="form-check-input"
                type="radio"
                name={info.row.original.ID_ASPECTO?.toString()}
                id={info.row.original.ID_ASPECTO?.toString()}
                value="Aplica"
                checked={info.row.original.ID_TIPO_EVALUACION === E_EstadoTipoEvaluacionLIO.Aplica ? true : false}
                onClick={(e) => {
                  if (vpp == null || gsg == null) {
                    MySwal.fire({
                      title: <p>Debe completar todos los campos requeridos</p>,
                      icon: "error",
                    });
                  } else {
                    setSelectedAspectoEvaluar(info.row.original);
                    setIsOpenPopUpApectoEvaluar(true);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Aplica
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                data-testid="test3"
                className="form-check-input"
                type="radio"
                name={info.row.original.ID_ASPECTO?.toString()}
                id={info.row.original.ID_ASPECTO?.toString()}
                value="No Aplica"
                checked={
                  info.row.original.ID_TIPO_EVALUACION == null || info.row.original.ID_TIPO_EVALUACION === E_EstadoTipoEvaluacionLIO.NoAplica
                    ? true
                    : false
                }
                onClick={(e) => {
                  if (vpp == null || gsg == null) {
                    MySwal.fire({
                      title: <p>Debe completar todos los campos requeridos</p>,
                      icon: "error",
                    });
                  } else {
                    handleSetAspecto(info.row.original, E_EstadoTipoEvaluacionLIO.NoAplica);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="inlineRadio3">
                No Aplica
              </label>
            </div>
          </div>
        )}
      </span>
    );
  };

  const componentEliminar = (info: any) => {
    return (
      <div>
        {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? (
          <i
            data-testid="test5"
            className="bi bi-trash iconTrash"
            title="Eliminar Documento"
            onClick={() => {
              MySwal.fire({
                html: (
                  <div>
                    <h3>¿Desea eliminar el documento {getFileName(info.row.original.URL)}?</h3>
                  </div>
                ),
                text: "",
                icon: "question",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                showCloseButton: true,
                showCancelButton: true,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await LIOService.deleteDocumentoLIO(token, info.getValue());
                  await refreshDocuments(info.row.original.ID_LIO_INSPECCION_OBSERVACION, null);
                }
              });
            }}></i>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  };

  const componentVer = (info: any) => {
    return (
      <div>
        <i
          data-testid="test4"
          className="bi bi-search iconSearch"
          title="Ver Documento"
          onClick={() => {
            DesviacionService.getContenidoArchivo(token, info.row.original.URL);
          }}></i>
      </div>
    );
  };

  usePromiseEffect(async () => {
    console.log(arrErrorEmptyFile);
    console.log(isLoadingAspectos);
    let token = await userInfoToken;
    setToken(token);
    let currUser = is_test
      ? { name: "", email: "", surname: "", fullname: "", roles: { IS_EXT_LIO: true }, external: false }
      : await cognitoUserInfo();
    setCurrentUser(currUser);
    let isExternalLIO = currUser.roles.IS_EXT_LIO || false;
    try {
      if (currUser.external && currUser?.roles.IS_EXT_LIO) {
        let params = {
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          TITULO: null,
          NOMBRE_INSPECTOR_CONTRATISTA: currUser.email,
          ID_GERENCIA_SUBGERENCIA: null,
          ACTIVO: null,
        };
        let result = is_test
          ? []
          : (await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`, { Authorization: `Bearer ${token}` }, params))
              .result.data;
        setIsExternoInspector(result.length > 0);
      }
    } catch (error) {}
    setIsExternalUser(isExternalLIO);
    let listEmpresaInspectoraUsuario = null;
    if (isExternalLIO) {
      let params = {
        PAGINA: 1,
        PAGINADO: ROW_COUNT,
        ORDENADOPOR: "ID",
        ORIENTACION: "DESC",
        TITULO: null,
        NOMBRE_INSPECTOR_CONTRATISTA: currUser.email,
        ID_GERENCIA_SUBGERENCIA: null,
        ACTIVO: null,
      };
      listEmpresaInspectoraUsuario = is_test
        ? [{ ID_GERENCIA: 1 }]
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`, { Authorization: `Bearer ${token}` }, params)).result
            .data;
      const idGerencia = listEmpresaInspectoraUsuario[0]?.ID_GERENCIA;
      const comboGSG = is_test
        ? [{ NOMBRE_VICEPRESIDENCIA: "", ID_VICEPRESIDENCIA: 1 }]
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall?ID=${idGerencia}`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle))
            .result.data;
      await fillComboGSG(comboGSG[0]?.NOMBRE_VICEPRESIDENCIA);
      const comboVPP = is_test
        ? [{ ID: 1 }]
        : (await getAPI(`${URL_SUPPORT}${API_VPP}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result.data;
      const idVicePresidencia = comboGSG[0]?.ID_VICEPRESIDENCIA;
      setVpp({
        label: comboVPP?.filter((vcc: any) => vcc.ID == idVicePresidencia)[0]?.TITULO,
        value: idVicePresidencia,
      });
      setSelectedInspeccionadoPor({
        USUARIO: currUser.email,
        USUARIO_DISPLAY: currUser.fullname,
      });
    }

    await fillCombos(listEmpresaInspectoraUsuario, isExternalLIO);
    if (idLIO) {
      let resultLIO: IInspeccionObservacion | null;

      if (is_test) {
        resultLIO = lioTest ?? itemsLIO[0];
      } else {
        resultLIO = await LIOService.getLIOByID(token, idLIO);
      }
      setSelectedLIO(resultLIO);
      if (resultLIO) {
        await refreshDocuments(resultLIO.ID, null);
        if (isExternalLIO) {
          await fillComboGSG(resultLIO?.VICEPRESIDENCIA);
        }
        await fillComboUP(resultLIO?.GERENCIA_SUBGERENCIA);
        await fillComboF(resultLIO?.TIPO_FAENA);
        await fillInspeccionadoPor(resultLIO?.GERENCIA_SUBGERENCIA);
        await handleReloadListadoAspectosInsObs(resultLIO?.ID_TIPO_FAENA, undefined, undefined, token, resultLIO?.ID);
        setLenObservacionesInc(resultLIO.OBSERVACIONES?.length || 0);
        setVpp({
          label: resultLIO?.VICEPRESIDENCIA,
          value: resultLIO?.ID_VICEPRESIDENCIA.toString(),
        });
        setGsg({
          label: resultLIO?.GERENCIA_SUBGERENCIA,
          value: resultLIO?.ID_GERENCIA_SUBGERENCIA.toString(),
        });
        setUp({
          label: resultLIO?.UNIDAD_PROYECTO,
          value: resultLIO?.ID_UNIDAD_PROYECTO.toString(),
        });
        setFechaDeteccion(moment(resultLIO?.FECHA_DETECCION).format("yyyy-MM-DD"));
        setObservaciones(resultLIO?.OBSERVACIONES);
        setInstalacionIntervenir(resultLIO?.INSTALACION_INTERVENIR);
        setNumeroTrabajoRealizado(resultLIO?.ATN);
        setJefeFaenaSupervisor(resultLIO?.JEFE_FAENA_SUPERVISOR);
        setCs({
          label: resultLIO?.CONTRATISTA_SUBCONTRATISTA,
          value: resultLIO?.ID_CONTRATISTA_SUBCONTRATISTA?.toString(),
        });
        setTF({
          label: resultLIO?.TIPO_FAENA,
          value: resultLIO?.ID_TIPO_FAENA.toString(),
          newFormat: resultLIO?.NUEVO_FORMATO_FAENA,
        });
        setF({
          label: resultLIO?.HORARIO != undefined ? resultLIO.HORARIO : "",
          value: resultLIO?.ID_FAENA?.toString(),
        });
        setSelectedInspeccionadoPor({
          USUARIO: resultLIO.INSPECTOR_FAENA,
          USUARIO_DISPLAY: resultLIO.INSPECTOR_FAENA_DISPLAY,
        });
      }
    }
    setIsLoading(false);
  }, []);

  const fillCombos = async (arrEmpresaInspectora: Array<any>, isExtenalInspector: boolean = false) => {
    let urls = [
      `${URL_SUPPORT}${API_VPP}/getall`,
      `${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`,
      `${URL_SUPPORT}${API_ADMIN_TIPO_FAENA}/getall`,
    ];
    let results = is_test
      ? [
          { data: { data: [] } },
          { data: { data: [] } },
          { data: { data: [] } },
          { data: { data: [] } },
          { data: { data: [] } },
          { data: { data: [] } },
          { data: { data: [] } },
        ]
      : await getAPIBatch(urls, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle);

    results.forEach((result, index) => {
      switch (index) {
        case 0:
          setComboVcc(result.data.data);
          break;
        case 1:
          if (isExtenalInspector) {
            let idEmpresa = arrEmpresaInspectora.map((ei) => ei.ID_EMPRESA_INSPECTORA);
            setComboCSC(result.data.data.filter((csc: any) => idEmpresa.includes(csc.ID)));
          } else {
            setComboCSC(result.data.data);
          }
          break;
        case 2:
          setComboTF(result.data.data);
          break;
      }
    });
  };

  const refreshDocuments = async (idLIO?: number, pagination?: IPagination | null) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = is_test
      ? { data: itemsDocumentos, pages: 10 }
      : await LIOService.getDocumentosLIO(token, {
          ...defaultPagination,
          ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
          ID_LIO_INSPECCION_OBSERVACION: idLIO || (selectedLIO?.ID as number),
        });
    totalPageListDocumentos.current = result.pages;
    setDocumentosLIO(result.data);
  };

  const handleReloadListadoAspectosInsObs = async (
    tfId: number | undefined,
    arrayAspectosTemporales?: IAspectoEvaluar[],
    params?: ISearchListadoAspectosInsObs,
    tokenString?: string,
    idIngresoLio?: number
  ) => {
    let paramsActive =
      params ||
      ({
        ORDENADOPOR: "ID",
        ORIENTACION: "ASC",
        PAGINA: 1,
        PAGINADO: ROW_COUNT_MAX,
      } as ISearchListadoAspectosInsObs);
    setIsLoadingAspectos(true);
    let userToken;
    if (token === "") {
      userToken = tokenString !== undefined ? tokenString : "";
    } else {
      userToken = token;
    }
    if (!params && tfId) {
      let result = is_test
        ? { data: items ?? [], pages: 10 }
        : await LIOService.getListadoAspectosInsObs(userToken, {
            ...paramsActive,
            ID_TIPO_FAENA: tfId,
            ID_LIO_INSPECCION_OBSERVACION: idIngresoLio || selectedLIO?.ID,
          });
      let arrAspectosInsObs = result.data;
      if (arrayAspectosTemporales != null) {
        arrAspectosInsObs = arrAspectosInsObs.map((a) => {
          const aspectoEvaluado = arrayAspectosTemporales.find((ev) => ev.ID_ASPECTO === a.ID_ASPECTO);
          if (aspectoEvaluado) {
            return {
              ...a,
              ACCION_REALIZADA: aspectoEvaluado.ACCION_REALIZADA,
              FECHA_HASTA: aspectoEvaluado.FECHA_HASTA,
              ID_TIPO_EVALUACION: aspectoEvaluado.ID_TIPO_EVALUACION,
              RESPONSABLE: aspectoEvaluado.RESPONSABLE,
              RESPONSABLE_DISPLAY: aspectoEvaluado.RESPONSABLE_DISPLAY,
            };
          } else {
            return a;
          }
        });
      }

      totalPageListLIO.current = result.pages;
      setListLIOAspectosInsObsFiltrado(arrAspectosInsObs);
      setListLIOAspectosInsObs(arrAspectosInsObs);
      if (arrayAspectosTemporales === undefined) {
        let listAspectosGuardados = arrAspectosInsObs.filter((ae) => ae.ID !== 0);
        setAspectoEvaluadoListaFaena(listAspectosGuardados);
      }
    } else {
      let listAspectos = is_test ? items : listLIOAspectosInsObs;
      if (paramsActive?.NUMERO) {
        listAspectos = listAspectos.filter((ae) =>
          (ae.ES_TITULO ? ae.TITULO : ae.ID_NODO_ASPECTO)?.toLocaleLowerCase().includes(paramsActive?.NUMERO.toLocaleLowerCase())
        );
      }
      if (paramsActive?.ASPECTO) {
        listAspectos = listAspectos.filter((ae) => ae.NOMBRE_ELEMENTO?.toLocaleLowerCase()?.includes(paramsActive?.ASPECTO.toLocaleLowerCase()));
      }
      if (paramsActive?.ID_TIPO_EVALUACION) {
        listAspectos = listAspectos.filter((ae) =>
          (ae.ID_TIPO_EVALUACION === E_EstadoTipoEvaluacionLIO.Estandar || !ae.ID_TIPO_EVALUACION ? "Estándar" : componentListAspectos(ae))
            .toLocaleLowerCase()
            .includes(paramsActive.ID_TIPO_EVALUACION?.toLocaleLowerCase())
        );
      }
      if (paramsActive?.RESPONSABLE) {
        listAspectos = listAspectos.filter((ae) =>
          ae.RESPONSABLE_DISPLAY?.toLocaleLowerCase().includes(paramsActive?.RESPONSABLE.toLocaleLowerCase())
        );
      }
      if (paramsActive?.FECHA_HASTA) {
        listAspectos = listAspectos.filter((ae) =>
          moment(paramsActive?.FECHA_HASTA).isValid()
            ? moment(paramsActive?.FECHA_HASTA).format("YYYY-MM-DD") === moment(ae.FECHA_HASTA).format("YYYY-MM-DD")
            : true
        );
      }
      if (paramsActive?.ACCION) {
        listAspectos = listAspectos.filter((ae) => ae.ACCION_REALIZADA?.includes(paramsActive?.ACCION.toLocaleLowerCase()));
      }
      setListLIOAspectosInsObsFiltrado(listAspectos);
      if (arrayAspectosTemporales === undefined) {
        let listAspectosGuardados = listAspectos.filter((ae) => ae.ID !== 0);
        setAspectoEvaluadoListaFaena(listAspectosGuardados);
      }
    }
    setIsLoadingAspectos(false);
  };

  const handleArrayAspectosTemporales = (aspectoEvaluado: IAspectoEvaluar) => {
    let arrayAspecto = is_test ? [] : [...aspectoEvaluadoListaFaena.filter((ae) => ae.ID_ASPECTO !== aspectoEvaluado.ID_ASPECTO), aspectoEvaluado];
    setAspectoEvaluadoListaFaena(arrayAspecto);
    handleReloadListadoAspectosInsObs(parseInt(tf?.value || ""), arrayAspecto);
  };
  const handleSetAspecto = async (rowAspecto: IAspectoEvaluar, tipoEvaluacion: E_EstadoTipoEvaluacionLIO) => {
    let obj = {
      ...rowAspecto,
      ID_TIPO_EVALUACION: tipoEvaluacion,
      ID_INSPECCION_OBSERVACION: null,
    };
    if (tipoEvaluacion === E_EstadoTipoEvaluacionLIO.NoAplica || tipoEvaluacion === E_EstadoTipoEvaluacionLIO.Estandar) {
      obj = {
        ...obj,
        RESPONSABLE: null,
        RESPONSABLE_DISPLAY: null,
        FECHA_HASTA: null,
        ACCION_REALIZADA: null,
      };
    }
    let aspecto = [...aspectoEvaluadoListaFaena.filter((ae) => ae.ID_ASPECTO !== rowAspecto.ID_ASPECTO), obj];
    setAspectoEvaluadoListaFaena(aspecto);
    handleReloadListadoAspectosInsObs(parseInt(tf?.value || ""), aspecto);
  };

  const fillComboGSG = async (vppId: string) => {
    setComboGSG([]);
    let paramsActive = {
      ...cParamsActive,
      VICEPRESIDENCIA: vppId,
    };
    const comboGSG = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboGSG(comboGSG);
  };

  const fillComboF = async (nF: string) => {
    setComboF([]);
    let paramsActive = {
      ...cParamsActive,
      NOMBRE_TIPO_FAENA: nF,
    };
    const comboF = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_FAENA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboF(comboF);
  };

  const fillComboUP = async (vppId: string) => {
    setComboUP([]);
    let paramsActive = {
      ...cParamsActive,
      NOMBRE_GERENCIA_SUBGERENCIA: vppId,
    };
    const comboUP = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboUP(comboUP);
  };

  const fillInspeccionadoPor = async (gerenciaTitle: string) => {
    let paramsActive = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT_MAX,
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      NOMBRE_GERENCIA: gerenciaTitle,
      ACTIVO: true,
    };
    const inspeccionadoPor: Array<ILIOInspectorTranselec> = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_INSPECTOR_TRANSELEC}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setInspeccionadoPor(inspeccionadoPor);
  };

  const formValidation = (value: Partial<IInspeccionObservacion>) => {
    let arrErrors: Array<string> = [];
    if (!value.ID_VICEPRESIDENCIA) {
      arrErrors.push("ID_VICEPRESIDENCIA");
    }

    if (!value.ID_GERENCIA_SUBGERENCIA) {
      arrErrors.push("ID_GERENCIA_SUBGERENCIA");
    }

    if (!value.ID_UNIDAD_PROYECTO) {
      arrErrors.push("ID_UNIDAD_PROYECTO");
    }

    if (!moment(value.FECHA_DETECCION).isValid()) {
      arrErrors.push("FECHA_DETECCION");
    }

    if (!value.ID_TIPO_FAENA) {
      arrErrors.push("ID_TIPO_FAENA");
    }

    if (!value.INSPECTOR_FAENA) {
      arrErrors.push("INSPECCIONADO_POR");
    }

    if (!value.INSTALACION_INTERVENIR) {
      arrErrors.push("INSTALACION_INTERVENIR");
    }

    if (!tf?.newFormat && !value.ATN) {
      arrErrors.push("NUMERO_TRABAJOS_REALIZADOS");
    }

    if (!tf?.newFormat && !value.JEFE_FAENA_SUPERVISOR) {
      arrErrors.push("JEFE_FAENA_SUPERVISOR");
    }

    if (!value.OBSERVACIONES) {
      arrErrors.push("OBSERVACIONES");
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const handleGuardarLIO = async (enviarLIO?: boolean) => {
    let listAspectosGuardadosPorTipoFaena = aspectoEvaluadoListaFaena.filter((ae) => ae.ID_TIPO_ASPECTO === Number(tf?.value) || ae.ID === null);
    let correoEncargadoZonal = tf?.newFormat
      ? null
      : comboGSG
          .filter((g) => g.ID == gsg?.value)
          .map((ip) => {
            return ip.ENCARGADO_ZONAL;
          })[0];
    let nombreEncargadoZonal = tf?.newFormat
      ? null
      : comboGSG
          .filter((g) => g.ID == gsg?.value)
          .map((ip) => {
            return ip.ENCARGADO_ZONAL_DISPLAY;
          })[0];
    let value: Partial<IInspeccionObservacion> = {
      ID_VICEPRESIDENCIA: parseInt(vpp?.value || ""),
      ID_GERENCIA_SUBGERENCIA: parseInt(gsg?.value || ""),
      ID_UNIDAD_PROYECTO: parseInt(up?.value || ""),
      ID_CONTRATISTA_SUBCONTRATISTA: parseInt(cs?.value || ""),
      FECHA_DETECCION: new Date(fechaDeteccion || ""),
      OBSERVACIONES: observaciones,
      INSTALACION_INTERVENIR: instalacionIntervenir,
      JEFE_FAENA_SUPERVISOR: jefeFaenaSupervisor,
      ID_TIPO_FAENA: parseInt(tf?.value || ""),
      FAENA: fa?.value,
      FECHA_CREACION: new Date(),
      ATN: numeroTrabajoRealizado,
      AUTOR: currentUser?.email as string,
      AUTOR_DISPLAY: currentUser?.fullname as string,
      USUARIO_CONTRATISTA: cs?.label,
      ID_TIPO_LISTA: 1,
      ID_ESTADO: E_EstadoLIO.EnConstruccion,
      INSPECTOR_FAENA: selectedInspeccionadoPor?.USUARIO,
      INSPECTOR_FAENA_DISPLAY: selectedInspeccionadoPor?.USUARIO_DISPLAY,
      ID: selectedLIO?.ID,
      TITULO: null,
      CORRELATIVO: selectedLIO?.CORRELATIVO,
      HORARIO: fa?.label,
      USUARIO_ENCARGADO_ZO: correoEncargadoZonal,
      ID_TIPO_INTERNO_EXTERNO: 1,
      ES_CERRAR_CON: null,
      CERRAR_CON_OBSERVACION: null,
      FECHA_CIERRE: new Date(),
      CERRADO_POR: null,
      TIENE_RECHAZO_ENCARGADO: null,
      RECHAZO_ENCARGADO_ZO: null,
      EDITOR: null,
      EDITOR_DISPLAY: null,
      FECHA_MODIFICACION: new Date(),
      TRANSACTION_ID: null,
      USUARIO_ENCARGADO_ZO_DISPLAY: nombreEncargadoZonal,
      ASPECTOS_EVALUAR: listAspectosGuardadosPorTipoFaena,
    };
    if (formValidation(value)) {
      setIsSendingData(true);
      let idIngresoLio = await LIOService.ingresoLIO(token, value);
      setSelectedLIO({
        ...selectedLIO,
        ...value,
        ID: selectedLIO?.ID || idIngresoLio,
        ID_ESTADO: E_EstadoLIO.EnConstruccion,
        CORRELATIVO:
          selectedLIO?.CORRELATIVO ||
          `${moment(value.FECHA_CREACION).format("M")}${moment(value.FECHA_CREACION).format("YYYY")}-${selectedLIO?.ID || idIngresoLio}`,
      } as IInspeccionObservacion);
      await handleReloadListadoAspectosInsObs(value.ID_TIPO_FAENA, undefined, undefined, token, idIngresoLio);
      setIsSendingData(false);
      return selectedLIO?.ID || idIngresoLio;
    } else {
      MySwal.fire({
        title: <p>Complete todos los campos requeridos</p>,
        icon: "error",
      });
      return -1;
    }
  };

  const handleEnviarLIO = async () => {
    let id = await handleGuardarLIO(true);
    if (id > -1) {
      setIsSendingData(true);
      await LIOService.enviarLIO(token, {
        ID: id,
        OBSERVACION: true,
        ENVIAR_NOTIFICACION: true,
        ASPECTOS_EVALUAR: aspectoEvaluadoListaFaena,
      });
      window.location.href = "/LIO";
    }
  };

  const callback = (id: any, value: Array<IUserPickerValue>) => {
    setSelectedInspeccionadoPor(
      value.length === 0
        ? null
        : {
            USUARIO: value[0]?.mail,
            USUARIO_DISPLAY: value[0]?.name,
          }
    );
  };

  const validateUploadFile = (value: Partial<IDocumentoLIO>) => {
    let arrErrors: Array<string> = [];

    if (!refInputFile.current?.files) {
      arrErrors.push("ARCHIVO");
    } else {
      if (documentosLIO.filter((l) => l.URL.includes((refInputFile.current?.files as FileList)[0].name)).length > 0) {
        arrErrors.push("ARCHIVO_DUPLICADO");
        MySwal.fire({
          html: (
            <div>
              <h3>Archivo "{(refInputFile.current?.files)[0].name}" ya se encuentra cargado</h3>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
      }
    }

    setArrErrorEmptyFile(arrErrors);
    return arrErrors.length === 0;
  };

  const handleGuardarDocumento = async () => {
    let f = (refInputFile.current?.files as FileList)[0] as any;
    let value: Partial<IDocumentoLIO> = {
      ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
      ID_LIO_INSPECCION_OBSERVACION: 46,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
    };

    if (validateUploadFile(value)) {
      if (refTxtDescripcionDocumento.current?.value) {
        refTxtDescripcionDocumento.current.value = "";
      }
      if (refInputFile.current?.files) {
        refInputFile.current.files = null;
        refInputFile.current.value = "";
      }
      setLenDescripcionDoc(0);
      setIsUploadingDocs(true);
      let idLIO = await handleGuardarLIO();
      if (idLIO > -1) {
        value.ID_LIO_INSPECCION_OBSERVACION = idLIO;
        await LIOService.addDocumentosLIO(token, value);
        await refreshDocuments(idLIO, null);
      }
      setIsUploadingDocs(false);
    }
  };

  function ModalCambiarTipoFaena(callBack: () => void) {
    MySwal.fire({
      html: (
        <div>
          <h3>¿Esta seguro que desea cambiar el Tipo de Faena?</h3>
          <div className="colorRojo">
            (Se eliminarán {tf?.newFormat ? "todas las acciones guardadas" : "todos los aspectos guardados"} anteriormente)
          </div>
        </div>
      ),
      icon: "question",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      showCloseButton: true,
      showCancelButton: true,
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        callBack();
      }
    });
  }

  const columnHelperLIOFaena = createColumnHelper<IAspectoEvaluar>();
  let columnsDefFaena = [
    columnHelperLIOFaena.accessor((row) => row.TITULO, {
      id: "NUMERO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Numero"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaena.accessor((row) => row.NOMBRE_ELEMENTO, {
      id: "ASPECTO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Aspecto"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaena.accessor((row) => row.ID_TIPO_EVALUACION, {
      id: "ID_TIPO_EVALUACION",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentAspectosEvaluados(info),
      header: () => component("Aspectos Evaluados"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaena.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Responsable"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaena.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      tipo: ITipo_Campo.date,
      disableSort: true,
    } as any),
    columnHelperLIOFaena.accessor((row) => row.ACCION_REALIZADA, {
      id: "ACCION",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Accion"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
  ] as any;

  const columnHelperLIOFaenaNuevoFormato = createColumnHelper<IAspectoEvaluar>();
  let columnsDefFaenaNuevoFormato = [
    columnHelperLIOFaenaNuevoFormato.accessor((row) => row.TITULO, {
      id: "NUMERO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Numero"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaenaNuevoFormato.accessor((row) => row.NOMBRE_ELEMENTO, {
      id: "ASPECTO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaenaNuevoFormato.accessor((row) => row.ID_TIPO_EVALUACION, {
      id: "ID_TIPO_EVALUACION",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentAspectosEvaluadosNuevoFormato(info),
      header: () => component("Aplicabilidad"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaenaNuevoFormato.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Responsable"),
      tipo: ITipo_Campo.text,
      disableSort: true,
    } as any),
    columnHelperLIOFaenaNuevoFormato.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      tipo: ITipo_Campo.date,
      disableSort: true,
    } as any),
  ] as any;

  const columnHelperLIODocumentos = createColumnHelper<IDocumentoLIO>();
  let columnsDefLIODocumentos = [
    columnHelperLIODocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => "Ingreso Lista", {
      id: "CATEGORIA",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue("Ingreso Lista"),
      header: () => component("Categoría"),
      tipo: ITipo_Campo.text,
      hide: true,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCIONES_VER",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCIONES_ELIMINAR",
      cell: (info: CellContext<IDocumentoLIO, number>) => componentEliminar(info),
      header: () => component(selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO === null ? "Eliminar" : ""), //
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: estadoFormulario === E_EstadoFormIngresarLIO.Lectura,
    } as any),
  ] as any;

  return isLoading ? (
    <Loading />
  ) : (
    <div className="rounded bg-white p-2 shadow">
      <button
        hidden={true}
        data-testid="btntest"
        onClick={() => {
          let params = {
            ACCION: "true",
            ASPECTO: "dd",
            FECHA_HASTA: "",
            ID_LIO_INSPECCION_OBSERVACION: 1,
            ID_TIPO_EVALUACION: "1",
            ID_TIPO_FAENA: 1,
            NUMERO: "",
            ORDENADOPOR: "",
            ORIENTACION: "",
            PAGINA: 1,
            PAGINADO: 10,
            RESPONSABLE: "",
          };
          handleReloadListadoAspectosInsObs(1, [], params, "");

          params.NUMERO = "";
          handleReloadListadoAspectosInsObs(1, [], params, "");
          params.ASPECTO = "";
          handleReloadListadoAspectosInsObs(1, [], params, "");

          params.ID_TIPO_EVALUACION = "";
          handleReloadListadoAspectosInsObs(1, [], params, "");

          handleArrayAspectosTemporales([] as IAspectoEvaluar);
        }}></button>
      <div className="container-fluid mb-4">
        <h1 className="titPrincipal colorTit">Inspección y Observación</h1>
        <div className="card bg-light border p-3 pt-2 mt-2">
          <Row>
            <Col xs={12} lg={6} md={6}>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Estado:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{selectedLIO?.ESTADO || "En Construcción"}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>N° Lista Inspección Observación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{selectedLIO?.CORRELATIVO}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Tipo Lista:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>Inspección / Observación</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Tipo de Faena:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.TIPO_FAENA}</span>
                  ) : (
                    <Select
                      options={
                        comboTF.map((tf) => ({
                          value: tf.ID,
                          label: tf.TITULO,
                          newFormat: tf.NUEVO_FORMATO,
                        })) as any
                      }
                      className={`${tf == null && arrErrorEmpty.includes("ID_TIPO_FAENA") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setTF(e || "");
                        fillComboF(e.label || "");
                        handleReloadListadoAspectosInsObs(e.value);
                      }}
                      value={tf}
                    />
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Faena:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.HORARIO}</span>
                  ) : (
                    <Select
                      options={
                        comboF.map((f) => ({
                          value: f.ID,
                          label: f.TITULO,
                        })) as any
                      }
                      className={`${fa == null && arrErrorEmpty.includes("ID_FAENA") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setF(e || "");
                      }}
                      value={fa}
                    />
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Vicepresidencia:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.VICEPRESIDENCIA}</span>
                  ) : (
                    <Select
                      options={
                        comboVcc.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${vpp == null && arrErrorEmpty.includes("ID_VICEPRESIDENCIA") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setVpp(e || "");
                        fillComboGSG(e.label || "");
                        setGsg(null);
                        setUp(null);
                      }}
                      isDisabled={isExternalUserLIO}
                      value={vpp}
                    />
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Gerencia/Subgerencia:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.GERENCIA_SUBGERENCIA}</span>
                  ) : (
                    <Select
                      options={
                        comboGSG.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${gsg == null && arrErrorEmpty.includes("ID_VICEPRESIDENCIA") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setGsg(e || "");
                        fillComboUP(e.label || "");
                        fillInspeccionadoPor(e.label || "");
                        setUp(null);
                      }}
                      value={gsg}
                    />
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Unidad/Proyecto:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.UNIDAD_PROYECTO}</span>
                  ) : (
                    <Select
                      options={
                        comboUP.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${up == null && arrErrorEmpty.includes("ID_UNIDAD_PROYECTO") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setUp(e || "");
                      }}
                      value={up}
                    />
                  )}
                </Col>
              </div>
            </Col>
            <Col xs={12} lg={6} md={6}>
              {!tf?.newFormat && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Contratista/Subcontratista:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                      <span>{selectedLIO?.CONTRATISTA_SUBCONTRATISTA}</span>
                    ) : (
                      <Select
                        options={
                          comboCSC.map((vcc) => ({
                            value: vcc.ID,
                            label: vcc.TITULO,
                          })) as any
                        }
                        placeholder="Seleccione"
                        isClearable={true}
                        onChange={(e: any) => {
                          setCs(e || "");
                        }}
                        value={cs}
                      />
                    )}
                  </Col>
                </div>
              )}
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Inspeccionado por:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.INSPECTOR_FAENA_DISPLAY}</span>
                  ) : (
                    <UserPickerData
                      name={"Inspeccionado por"}
                      callback={callback}
                      id={"inspeccionadoPor"}
                      key={"1"}
                      multi={false}
                      disabled={isExternalUserLIO}
                      className={`${inspeccionadoPor.length === 0 && arrErrorEmpty.includes("INSPECCIONADO_POR") && "error"} borderColorGris`}
                      defaultValue={
                        selectedInspeccionadoPor
                          ? [
                              {
                                mail: selectedInspeccionadoPor.USUARIO as string,
                                name: selectedInspeccionadoPor.USUARIO_DISPLAY as string,
                              },
                            ]
                          : componentExternalUser()
                      }
                      options={inspeccionadoPor.map((ip) => {
                        return {
                          mail: ip.USUARIO as string,
                          name: ip.USUARIO_DISPLAY as string,
                        };
                      })}
                      currentUser={currentUser}
                      isExternoInspector={isExternoInspector}
                    />
                  )}
                </Col>
              </div>
              {selectedLIO && selectedLIO.USUARIO_ENCARGADO_ZO_DISPLAY && !tf?.newFormat && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Encargado Zonal:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    {selectedLIO.USUARIO_ENCARGADO_ZO_DISPLAY}
                  </Col>
                </div>
              )}
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha de creación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{shortDate(selectedLIO?.FECHA_CREACION)}</p>
                </Col>
              </div>

              {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? (
                ""
              ) : (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Creado por:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <p>{selectedLIO?.AUTOR_DISPLAY}</p>
                  </Col>
                </div>
              )}
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Fecha Detección:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{shortDate(selectedLIO?.FECHA_DETECCION)}</span>
                  ) : (
                    <Form.Control
                      onChange={(e) => {
                        setFechaDeteccion(e.target.value);
                      }}
                      type="date"
                      defaultValue={selectedLIO?.FECHA_DETECCION ? moment(selectedLIO?.FECHA_DETECCION).format("yyyy-MM-DD") : fechaDeteccion}
                      className={`${fechaDeteccion == undefined && arrErrorEmpty.includes("FECHA_DETECCION") && "error"}`}
                      max={moment().format(dateFormatInputReference)}
                    />
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Instalación a intervenir:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.INSTALACION_INTERVENIR}</span>
                  ) : (
                    <TextField
                      className={`${instalacionIntervenir == "" && arrErrorEmpty.includes("INSTALACION_INTERVENIR") && "error"} borderGris`}
                      defaultValue={selectedLIO?.INSTALACION_INTERVENIR}
                      onChange={(e) => {
                        setInstalacionIntervenir((e as React.ChangeEvent<HTMLInputElement>).target.value);
                      }}></TextField>
                  )}
                </Col>
              </div>
              {!tf?.newFormat && (
                <>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <span className="text-danger">
                        {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                      </span>
                      <label>N° de trabajo realizado:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                        <span>{selectedLIO?.ATN}</span>
                      ) : (
                        <TextField
                          className={`${numeroTrabajoRealizado == "" && arrErrorEmpty.includes("NUMERO_TRABAJOS_REALIZADOS") && "error"} borderGris`}
                          defaultValue={selectedLIO?.ATN}
                          onChange={(e) => {
                            setNumeroTrabajoRealizado((e as React.ChangeEvent<HTMLInputElement>).target.value);
                          }}></TextField>
                      )}
                    </Col>
                  </div>

                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <span className="text-danger">
                        {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                      </span>
                      <label>Jefe Faena o Supervisor:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                        <span>{selectedLIO?.JEFE_FAENA_SUPERVISOR}</span>
                      ) : (
                        <TextField
                          className={`${jefeFaenaSupervisor == "" && arrErrorEmpty.includes("JEFE_FAENA_SUPERVISOR") && "error"} borderGris`}
                          defaultValue={selectedLIO?.JEFE_FAENA_SUPERVISOR}
                          onChange={(e) => {
                            setJefeFaenaSupervisor((e as React.ChangeEvent<HTMLInputElement>).target.value);
                          }}></TextField>
                      )}
                    </Col>
                  </div>
                </>
              )}
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? <strong>(*)</strong> : ""}
                  </span>
                  <label>Observaciones:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
                    <span>{selectedLIO?.OBSERVACIONES}</span>
                  ) : (
                    <div>
                      <TextField
                        multiline
                        className={`${observaciones == "" && arrErrorEmpty.includes("OBSERVACIONES") && "error"} borderGris`}
                        onChange={(e) => {
                          setLenObservacionesInc((e as React.ChangeEvent<HTMLTextAreaElement>).target.value.length);
                          setObservaciones((e as React.ChangeEvent<HTMLTextAreaElement>).target.value);
                        }}
                        defaultValue={selectedLIO?.OBSERVACIONES}
                        maxLength={1000}></TextField>
                      <span>{lenObservacionesInc}/1000</span>
                    </div>
                  )}
                </Col>
              </div>
            </Col>
          </Row>

          <div className="row mb-2 ajusteInput">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
              <h5 className="titPaneles">
                {selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion || selectedLIO == null ? "Adjuntar Evidencias" : ""}
              </h5>
            </div>
            {estadoFormulario === E_EstadoFormIngresarLIO.Lectura ? (
              <></>
            ) : (
              <div className="row border m-1 p-1 rounded">
                <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                  <label>Descripción</label>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                  <textarea
                    className="form-control form-control-sm"
                    rows={3}
                    ref={refTxtDescripcionDocumento}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                      setLenDescripcionDoc(e.target.value.length);
                    }}
                    maxLength={250}></textarea>
                  <span>{lenDescripcionDoc}/250</span>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                  <label>Adjuntar </label>
                  <span className="text-danger">
                    <small> Peso maximo (50 mb).</small>
                  </span>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                  <div className="input-group">
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="inputGroupFile04"
                      aria-describedby="inputGroupFileAddon04"
                      aria-label="Seleccionar Archivos"
                      ref={refInputFile}
                    />
                    {isUploadingDocs ? (
                      <Loading />
                    ) : (
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        id="inputGroupFileAddon04"
                        onClick={() => {
                          if (selectedLIO?.ID !== undefined && selectedLIO.ID > 0 && Number(tf?.value) !== selectedLIO?.ID_TIPO_FAENA) {
                            ModalCambiarTipoFaena(() => {
                              handleGuardarDocumento();
                            });
                          } else {
                            handleGuardarDocumento();
                          }
                        }}>
                        Subir
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container-fluid mb-4">
        <div className="card bg-light border p-3 pt-2 mt-2">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
            <h5 className="titPaneles">Evidencias</h5>
          </div>
          <AdminListaPagination
            defaultSortBy="ID"
            sortDirection="DESC"
            totalPages={totalPageListDocumentos}
            resultPerPage={ROW_COUNT}
            callback={(pagination) => {
              refreshDocuments(idLIO || selectedLIO?.ID, pagination);
            }}
            data={documentosLIO}
            reload={() => {
              refreshDocuments(idLIO || selectedLIO?.ID);
            }}
            columnsDef={columnsDefLIODocumentos}
            hideAdd={true}
            hideExport={true}
          />
        </div>
      </div>

      <div className="container-fluid mb-4">
        <div className="card bg-light border p-3 pt-2 mt-2">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
            <h5 className="titPaneles">{tf?.newFormat ? "Listado de Acciones" : "Listado de Tipo de Faena"}</h5>
          </div>
          <div className="table-responsive">
            {tf != null && !tf.newFormat && (
              <AdminListaPagination
                defaultSortBy="ID"
                sortDirection="ASC"
                hidePagination={true}
                totalPages={totalPageListLIO}
                resultPerPage={ROW_COUNT_MAX}
                data={listLIOAspectosInsObsFiltrado}
                reload={() => {
                  handleReloadListadoAspectosInsObs(parseInt(tf?.value || ""), aspectoEvaluadoListaFaena);
                }}
                columnsDef={columnsDefFaena}
                hideAdd={true}
                hideExport={true}
                options={{
                  getClassName: (row: RowDT<IAspectoEvaluar>) => (row.original.ES_TITULO ? "bg-filaGrilla" : ""),
                }}
                callback={(pagination) => {
                  handleReloadListadoAspectosInsObs(parseInt(tf?.value || ""), aspectoEvaluadoListaFaena, pagination as ISearchListadoAspectosInsObs);
                }}
              />
            )}
            {tf != null && tf.newFormat && (
              <AdminListaPagination
                defaultSortBy="ID"
                sortDirection="ASC"
                hidePagination={true}
                totalPages={totalPageListLIO}
                resultPerPage={ROW_COUNT_MAX}
                data={listLIOAspectosInsObsFiltrado}
                reload={() => {
                  handleReloadListadoAspectosInsObs(parseInt(tf?.value || ""), aspectoEvaluadoListaFaena);
                }}
                columnsDef={columnsDefFaenaNuevoFormato}
                hideAdd={true}
                hideExport={true}
                options={{
                  getClassName: (row: RowDT<IAspectoEvaluar>) => (row.original.ES_TITULO ? "bg-filaGrilla" : ""),
                }}
                callback={(pagination) => {
                  handleReloadListadoAspectosInsObs(parseInt(tf?.value || ""), aspectoEvaluadoListaFaena, pagination as ISearchListadoAspectosInsObs);
                }}
              />
            )}
          </div>

          {isSendingData ? (
            <Loading />
          ) : (
            <div className="row mb-2 ajusteInput mt-4">
              <Col xs="12" md="12" lg="12" className="text-center">
                {selectedLIO == null || selectedLIO?.ID_ESTADO === E_EstadoLIO.EnConstruccion ? (
                  <span>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        if (selectedLIO?.ID !== undefined && selectedLIO.ID > 0 && Number(tf?.value) !== selectedLIO?.ID_TIPO_FAENA) {
                          ModalCambiarTipoFaena(() => {
                            handleGuardarLIO();
                          });
                        } else {
                          handleGuardarLIO();
                        }
                      }}
                      disabled={isSendingData}>
                      Guardar
                    </button>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        let mensajeTipoFaena =
                          selectedLIO?.ID !== undefined && selectedLIO.ID > 0 && Number(tf?.value) !== selectedLIO?.ID_TIPO_FAENA
                            ? "Tenga en cuenta que esta cambiando el Tipo de Faena, se eliminarán todos los aspetos guardados anteriormente"
                            : "";
                        ModalContinuarLio(() => {
                          handleEnviarLIO();
                        }, mensajeTipoFaena);
                      }}
                      disabled={isSendingData}>
                      Continuar
                    </button>
                  </span>
                ) : (
                  <></>
                )}
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    window.location.href = "/lio";
                  }}
                  disabled={isSendingData}>
                  Volver
                </button>
              </Col>
            </div>
          )}
        </div>
      </div>
      {isOpenPopUpApectoEvaluar && (
        <AspectoEvaluar
          token={token}
          selectedLIO={{
            GERENCIA_SUBGERENCIA: gsg?.label || "",
            CONTRATISTA_SUBCONTRATISTA: cs?.label || "",
          }}
          onClose={async () => {
            setIsOpenPopUpApectoEvaluar(false);
            setSelectedAspectoEvaluar(null);
          }}
          aspectoEvaluar={selectdAspectoEvaluar}
          onSave={(aspectoEvaluado: IAspectoEvaluar) => {
            setIsOpenPopUpApectoEvaluar(false);
            handleArrayAspectosTemporales(aspectoEvaluado);
          }}
          tipoFaena={tf}
        />
      )}
    </div>
  );
};
export default AgregarLIO;
